import formulario from "../lib/formulario";
import {IDataLayer} from "../app";

interface Texto {
    titulo: string;
    texto: string;
}

interface DatosPregunta {
    correcta: number;
    explicacion: Texto;
    datos: Texto;
}

const pregunta = (pregunta: HTMLElement, onAcertada: () => void) => {
    const {correcta, explicacion, datos} = JSON.parse(pregunta.dataset.pregunta!) as DatosPregunta;
    const botones = Array.from(pregunta.querySelectorAll<HTMLButtonElement>('button'));
    let acertada = false;
    let informacionMostrada = false;

    const abreInformacion = () => {
        informacionMostrada = true;
        const contenedorExplicacion = document.createElement('div');

        contenedorExplicacion.classList.add('trivial__explicacion');
        contenedorExplicacion.innerHTML = `
                    <div class="trivial__explicacion__contenido" id="explicacion">
                        <button aria-controls="explicacion">X</button>
                        <h3>${explicacion.titulo}</h3>
                        <div>${explicacion.texto}</div>
                    </div>
                `;

        const cierraExplicacion = () => {
            contenedorExplicacion.classList.remove('is-visible');
            contenedorExplicacion.addEventListener('transitionend', () => {
                contenedorExplicacion.remove();
            }, {once: true});

            pregunta.classList.remove('is-girada');
            informacionMostrada = false;
        }

        contenedorExplicacion.querySelector('button')!.addEventListener('click', cierraExplicacion);

        document.documentElement.appendChild(contenedorExplicacion);
        requestAnimationFrame(() => {
            contenedorExplicacion.classList.add('is-visible');
        });

        contenedorExplicacion.addEventListener('click', (e) => {
            if (e.target === contenedorExplicacion) {
                cierraExplicacion();
            }
        });
    }

    botones.forEach((boton, index) => {
        boton.addEventListener('click', () => {
            if (informacionMostrada) {
                return;
            }

            if (acertada) {
                if (index == correcta) {
                    abreInformacion();
                }

                return;
            }

            acertada = index === correcta;

            if (acertada) {
                boton.classList.add('is-correcta');
                onAcertada();
                abreInformacion();
            } else {
                boton.classList.add('is-incorrecta');

                setTimeout(() => {
                    boton.classList.remove('is-incorrecta');
                }, 1000);
            }
        })
    });
}

const ocultaBloques = (bloquesOcultos: number[]) => {
    const bloques = Array.from(document.querySelectorAll<HTMLElement>('.bloque'));
    bloquesOcultos.forEach(x => bloques[x].style.display = 'none');
}

const muestraBloques = (bloquesVisibles: number[]) => {
    if (bloquesVisibles.length === 0) {
        return;
    }

    const bloques = Array.from(document.querySelectorAll<HTMLElement>('.bloque'));
    bloquesVisibles.forEach(x => bloques[x].style.display = 'block');

    requestAnimationFrame(() => {
        const bloque = bloques[bloquesVisibles[0]];
        const {top} = bloque.getBoundingClientRect();
        const scrollY = window.scrollY;
        window.scrollTo(0, top + scrollY - 100);
    })
}

const ocultaTarjetas = (preguntas: HTMLElement[]) => preguntas.forEach(p => p.classList.remove('is-girada'))

const giraTarjeta = (preguntas: HTMLElement[], index: number) => {
    ocultaTarjetas(preguntas);
    preguntas[index].classList.add('is-girada');
}

const tarjetas = (preguntas: HTMLElement[], onCompletado: () => void) => {
    const enlaces = preguntas.map(x => x.querySelector<HTMLAnchorElement>('a')!);

    // Eliminamos el retraso que se usa para cuando caen las tarjetas, para que no tarden al girar
    preguntas.forEach(pregunta => pregunta.addEventListener('transitionend', () => {
        pregunta.style.transitionDelay = '0s';
    }, {once: true}));

    enlaces.forEach((enlace, index) => enlace.addEventListener('click', (e) => {
        e.preventDefault();
        giraTarjeta(preguntas, index);
    }));

    let correctas = 0;
    preguntas.forEach(x => pregunta(x, () => {
        correctas += 1;

        if (correctas === preguntas.length) {
            onCompletado();
        }
    }));
}

const trivial = () => {
    const dataLayer = (window as any).dataLayer as IDataLayer;
    Array.from(document.querySelectorAll<HTMLDivElement>('.bloque--trivial')).forEach(bloque => {
        const form = bloque.querySelector('.trivial__formulario') as HTMLElement;

        const contenedor = bloque.querySelector<HTMLElement>('.trivial__preguntas')!;

        contenedor.style.display = 'none';
        //form.style.display = 'none';

        formulario(`#${bloque.id} form`, {
            dataLayer,
            ocultarEtiquetas: true,
            enviado: () => {
                form.style.display = 'none';
                contenedor.style.display = 'grid';
            }
        })

        const preguntas = Array.from(contenedor.querySelectorAll<HTMLDivElement>('.trivial__pregunta'));

        const bloquesOcultos = contenedor.dataset.bloquesOcultos?.split(',').map(x => parseInt(x) - 1) || [];
        // Ocultamos los bloques que se deban ocultar al iniciar el trivial
        ocultaBloques(bloquesOcultos);

        // Gestionamos los clics fuera de las tarjetas, para ocultar la tarjeta activa
        bloque.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;

            if (!target.closest('.trivial__pregunta')) {
                ocultaTarjetas(preguntas);
            }
        });

        // Tras responder todas las preguntas, mostramos los bloques que estaban ocultos
        tarjetas(preguntas, () => muestraBloques(bloquesOcultos));

        contenedor.classList.add('is-inicializada');
    });
}

export default trivial;